<template>
  <div>
    <!-- :style="{ background: 'rgb(190, 200, 200)'}" -->
    <a-card :style="{ background: 'rgb(190, 200, 200)'}" :bordered="false" >
      <a-button
        style=" margin-bottom: 10px;"
        ghost
        @click="$refs.createForm.handleAdd(parentId)"
        icon="plus"
        type="primary"
        size="small"> 新增 </a-button>
      <a-table
        size="small"
        rowKey="id"
        :loading="loading"
        :columns="columns"
        :data-source="list"
        :pagination="false">
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, 2)" v-hasPermi="['system:IndustryClassificationSon:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['system:IndustryClassificationSon:remove']"> <a-icon type="delete" />删除 </a>
        </span>
      </a-table>
    </a-card>
    <!-- 新增修改 -->
    <CreateDataForm @ok="getIndustryCategoryDetail" ref="createForm" :industryCategoryType="2" />
  </div>
</template>

<script>
import CreateDataForm from './CreateDataForm'
import { industryCategoryList, deleteIndustryCategory } from '@/api/system/industry'
export default {
  name: 'DictData',
  props: {
    parentId: {
      type: Number,
      required: true
    }
  },
  components: {
    CreateDataForm
  },
  data () {
    return {
      list: [],
      tableSize: 'small',
      columns: [
        {
          title: '行业',
          dataIndex: 'industryCategoryName',
          // align: 'center',
          key: 'industryCategoryName'
        },
        {
          title: '分类',
          dataIndex: 'industryCategoryType',
          ellipsis: true,
          // align: 'center',
          key: 'industryCategoryType'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      loading: false
    }
  },
  filters: {},
  created () {
    this.getIndustryCategoryDetail()
  },
  methods: {
    // 获取子级列表
    getIndustryCategoryDetail () {
      this.loading = true
      const parmars = {
        parentId: this.parentId,
        industryCategoryType: 2
      }
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res
        this.loading = false
        if (code === 200) {
          this.list = data
        }
      })
    },
    // 删除行业分类
    handleDelete (record) {
      deleteIndustryCategory(record.id).then(({ code }) => {
        if (code === 200) {
          this.$message.success('删除成功')
          this.getIndustryCategoryDetail()
        }
      })
    }
  },
  computed: {},
  watch: {}
}
</script>
<style scoped lang="less">
tr.ant-table-expanded-row {
  background-color: red;

}
</style>
